/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contactinformationupdated2Inputs */

const en_contactinformationupdated2 = /** @type {(inputs: Contactinformationupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact information updated`)
};

const de_contactinformationupdated2 = /** @type {(inputs: Contactinformationupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktinformationen aktualisiert`)
};

/**
* | output |
* | --- |
* | "Contact information updated" |
*
* @param {Contactinformationupdated2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contactinformationupdated2 = /** @type {((inputs?: Contactinformationupdated2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contactinformationupdated2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contactinformationupdated2(inputs)
	return de_contactinformationupdated2(inputs)
});
export { contactinformationupdated2 as "contactInformationUpdated" }